<template>
  <div>
    <div class="size-picker">
      <div class="mb-1 flex items-center" data-testid="show-sizes-overlay">
        <Headline class="mr-2" tag="span" look="h5" inline>
          {{ $t('pdp.size_heading') }}
        </Headline>
      </div>
      <div>
        <div class="mt-3 text-base">
          {{
            props.skiGogglesSize.value === 'one_size'
              ? $t('pdp.one_size')
              : props.skiGogglesSize.label
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SkiGogglesSize } from '~/types/pdp'

const props = defineProps({
  skiGogglesSize: {
    type: Object as PropType<SkiGogglesSize>,
    required: true,
  },
})
defineEmits(['update:packageUnit'])
</script>
